module.exports = __webpack_public_path__ + "static/media/social-ng.7bc77add.png";